export const authEvents = new EventTarget()
